import axios from "axios";
import Vue from "vue";
import { Notify } from "vant";
import router from "../../router";
// import nprogress from 'nprogress';
// import 'nprogress/nprogress.css';
axios.defaults.baseURL = "/api";

const sample = axios.create();

/* 请求拦截器 */
sample.interceptors.request.use(
  (config) => {
    if (window.localStorage.getItem("tokenLook")) {
      config.headers["Authorization"] =
        "Bearer " + window.localStorage.getItem("tokenLook");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* 响应拦截 */
sample.interceptors.response.use(
  (success) => {
    //业务逻辑错误，但接口访问成功
    if (success.status) {
      if (success.data.code) {
        if (success.data.code == 401) {
          var config = success.config;
          // 创建延时器等待发送重试请求
          var backoff = new Promise((resolve) => {
            sample({
              method: "post",
              url: `/getTokenByUserId`,
              data: { userId: window.localStorage.getItem("userId") },
            }).then(function (res) {
              window.localStorage.setItem("tokenLook", res.data.token.token);
              resolve();
            });
          });
          return backoff.then(() => {
            return sample(config);
          });
        } else if (success.data.message) {
          // Notify({ message: success.data.message })
        }
      } else {
        window.localStorage.removeItem("tokenLook");
      }
    }
    return success.data;
  },
  (error) => {
    //访问接口失败
    if (error.response.data.code == 504 || error.response.data.code == 404) {
      Notify({ message: "服务器被吃了" });
    } else if (error.response.data.code == 403) {
      Notify({ message: "权限不足，请联系管理员！" });
    } else if (error.response.data.code == 401) {
      Notify({ message: "尚未登录，请登录" });
    } else {
      //没有响应码
      if (error.response.data.meesage) {
        Notify({ meesage: error.response.data.meesage });
      } else {
        Notify({ message: "未知错误！" });
      }
    }
    return;
  }
);

let base = "";
//请求接口
export const fileRequest = (url) => {
  return sample({
    method: "post",
    url: `${base}${url}`,
    responseType: "blob",
  });
};

export const postRequest = (url, params, headers) => {
  return sample({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: { headers },
  });
};

export const putRequest = (url, params) => {
  return sample({
    method: "put",
    url: `${base}${url}`,
    data: params,
  });
};
//请求接口
export const getRequest = (url, params, isLoad) => {
  return sample({
    method: "get",
    url: `${base}${url}`,
    params: params,
  });
};

//请求接口
export const deleteRequest = (url, params) => {
  return sample({
    method: "delete",
    url: `${base}${url}`,
    data: params,
  });
};
